import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import ExportButton from '../../components/ExportButton';

const B = '#0B3D6E', T = '#0F6E56';

export default function AdminSettings() {
  const { user } = useAuth();
  const [pwForm, setPwForm] = useState({ currentPassword:'', newPassword:'', confirm:'' });
  const [saving, setSaving] = useState(false);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirm) { toast.error('Les mots de passe ne correspondent pas'); return; }
    if (pwForm.newPassword.length < 6) { toast.error('Mot de passe trop court'); return; }
    setSaving(true);
    try {
      await api.put('/auth/change-password', { currentPassword:pwForm.currentPassword, newPassword:pwForm.newPassword });
      toast.success('Mot de passe mis à jour ✅');
      setPwForm({ currentPassword:'', newPassword:'', confirm:'' });
    } catch(err) {
      toast.error(err.response?.data?.message || 'Erreur');
    } finally { setSaving(false); }
  };

  const inp = { width:'100%', border:'1px solid #e2e8f0', borderRadius:8, padding:'10px 12px', fontSize:13, background:'#f8fafc', outline:'none', fontFamily:'inherit', boxSizing:'border-box' };

  const Section = ({ title, icon, children }) => (
    <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', marginBottom:16 }}>
      <div style={{ padding:'1rem 1.5rem', borderBottom:'1px solid #f1f5f9', display:'flex', alignItems:'center', gap:8 }}>
        <span style={{ fontSize:18 }}>{icon}</span>
        <h2 style={{ fontSize:15, fontWeight:600, margin:0 }}>{title}</h2>
      </div>
      <div style={{ padding:'1.5rem' }}>{children}</div>
    </div>
  );

  return (
    <div style={{ padding:'1.5rem', maxWidth:800, margin:'0 auto' }}>
      <h1 style={{ fontSize:20, fontWeight:600, marginBottom:'1.5rem' }}>Paramètres & Outils</h1>

      {/* Profile */}
      <Section title="Compte administrateur" icon="👤">
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:16 }}>
          {[['Identifiant',user?.username||'—'],['Email',user?.email||'—'],['Rôle',user?.role||'—'],['Plan',user?.plan||'—']].map(([l,v])=>(
            <div key={l}><div style={{ fontSize:11, color:'#94a3b8', marginBottom:3 }}>{l}</div><div style={{ fontSize:14, fontWeight:500 }}>{v}</div></div>
          ))}
        </div>
      </Section>

      {/* Change password */}
      <Section title="Changer le mot de passe" icon="🔐">
        <form onSubmit={handlePasswordChange} style={{ display:'flex', flexDirection:'column', gap:12, maxWidth:360 }}>
          <div><label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Mot de passe actuel</label><input type="password" style={inp} value={pwForm.currentPassword} onChange={e=>setPwForm({...pwForm,currentPassword:e.target.value})} required/></div>
          <div><label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Nouveau mot de passe</label><input type="password" style={inp} value={pwForm.newPassword} onChange={e=>setPwForm({...pwForm,newPassword:e.target.value})} required/></div>
          <div><label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Confirmer</label><input type="password" style={{ ...inp, borderColor:pwForm.confirm&&pwForm.newPassword!==pwForm.confirm?'#dc2626':'#e2e8f0' }} value={pwForm.confirm} onChange={e=>setPwForm({...pwForm,confirm:e.target.value})} required/></div>
          <button type="submit" disabled={saving} style={{ background:saving?'#94a3b8':B, color:'#fff', border:'none', padding:'10px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer', width:'fit-content', paddingLeft:20, paddingRight:20 }}>
            {saving?'Mise à jour...':'Mettre à jour'}
          </button>
        </form>
      </Section>

      {/* Exports */}
      <Section title="Export des données" icon="📥">
        <div style={{ fontSize:13, color:'#64748b', marginBottom:16, lineHeight:1.7 }}>
          Téléchargez vos données en format CSV, compatible Excel, LibreOffice et Google Sheets.
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:12 }}>
          {[
            { type:'orders',   label:'Commandes LOMED',    desc:'Toutes les commandes avec statuts', icon:'📋' },
            { type:'products', label:'Catalogue produits', desc:'Liste complète du catalogue', icon:'💊' },
            { type:'stock',    label:'Stock global clients', desc:'Stock de tous les clients StockMed', icon:'📦' },
            { type:'contacts', label:'Messages contact',   desc:'Tous les messages reçus', icon:'✉️' },
          ].map(exp=>(
            <div key={exp.type} style={{ background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, padding:'1rem' }}>
              <div style={{ fontSize:24, marginBottom:8 }}>{exp.icon}</div>
              <div style={{ fontSize:13, fontWeight:600, marginBottom:3 }}>{exp.label}</div>
              <div style={{ fontSize:11, color:'#94a3b8', marginBottom:10, lineHeight:1.5 }}>{exp.desc}</div>
              <ExportButton type={exp.type} label="Télécharger CSV"/>
            </div>
          ))}
        </div>
      </Section>

      {/* App info */}
      <Section title="Informations système" icon="ℹ️">
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          {[
            ['Version app','LOMED MEDICARE v3.0'],
            ['Backend','Node.js + Express + MongoDB'],
            ['Frontend','React 18 + TanStack Query'],
            ['Hébergement','Vercel (frontend) + Railway (backend)'],
            ['Base de données','MongoDB Atlas'],
            ['Email','Resend API'],
          ].map(([l,v])=>(
            <div key={l}><div style={{ fontSize:11, color:'#94a3b8', marginBottom:2 }}>{l}</div><div style={{ fontSize:12, fontWeight:500, color:'#475569' }}>{v}</div></div>
          ))}
        </div>
        <div style={{ marginTop:16, background:'#E1F5EE', border:'1px solid #9FE1CB', borderRadius:8, padding:'10px 12px', fontSize:12, color:T }}>
          ✅ Toutes les fonctionnalités sont opérationnelles — Rate limiting actif — Données sécurisées
        </div>
      </Section>

      {/* Chat support widget info */}
      <Section title="Support client intégré" icon="💬">
        <div style={{ fontSize:13, color:'#64748b', marginBottom:14, lineHeight:1.7 }}>
          Le widget de chat Tawk.to est configuré sur le site. Les visiteurs peuvent contacter votre équipe en temps réel depuis toutes les pages.
        </div>
        <a href="https://dashboard.tawk.to" target="_blank" rel="noreferrer" style={{ display:'inline-flex', alignItems:'center', gap:6, background:B, color:'#fff', padding:'8px 16px', borderRadius:8, fontSize:13, fontWeight:600, textDecoration:'none' }}>
          📊 Voir le dashboard Tawk.to →
        </a>
      </Section>
    </div>
  );
}

